import { Button, ButtonSize, ButtonVariant } from "@next-platform/client-common-spicy-ui";
import React from "react";

import Trans from "@/components/Trans/Trans";
import { PresetEditDialogProps } from "@/pages/Chat/components/ModalGenerationSettings/PresetsManager/types";

export function PresetEditDialog({ editingName, onNameChange, onSave, onCancel, isDisabled, isUpdating }: PresetEditDialogProps) {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
      onSave();
    } else if (e.key === "Escape") {
      e.preventDefault();
      e.stopPropagation();
      onCancel();
    }
  };

  return (
    <div className="flex flex-col p-3 border border-gray-6 rounded-md bg-gray-2 dark:bg-gray-5 gap-2">
      <input
        type="text"
        value={editingName}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onNameChange(e.target.value)}
        onKeyDown={handleKeyDown}
        className="px-2 py-1.5 rounded border border-gray-6 bg-gray-1 dark:bg-gray-3 text-gray-12 text-sm focus:outline-none focus:ring-2 focus:ring-purple-9"
        autoFocus
        disabled={isDisabled || isUpdating}
      />
      <div className="flex flex-row gap-2">
        <Button size={ButtonSize.SMALL} variant={ButtonVariant.OUTLINED} onClick={onCancel} disabled={isDisabled || isUpdating}>
          <Trans i18nKey="common:cancel" />
        </Button>
        <Button size={ButtonSize.SMALL} onClick={onSave} disabled={isDisabled || isUpdating || !editingName.trim()}>
          {isUpdating ? <Trans i18nKey="chat:modal.generationSettings.presets.editSaving" /> : <Trans i18nKey="common:save" />}
        </Button>
      </div>
    </div>
  );
}
